import BillingsOrderRelatedTaxiTaxiResponse, {
  BillingsOrderRelatedTaxiTaxiResponseContractBillingModel,
  BillingsOrderRelatedTaxiTaxiResponseDate,
  BillingsOrderRelatedTaxiTaxiResponseDateBillingStatus,
  BillingsOrderRelatedTaxiTaxiResponseOrderForwardingAction,
} from "../../../../../api/raily/billings/order/related/taxi-taxi/billings-order-related-taxi-taxi.response";
import BillingModel from "../../../../../types/billing-model";
import BillingStatus from "../../../../../types/billing-status";
import BillingsOrderRelatedTaxiTaxi, {
  BillingsOrderRelatedTaxiTaxiItem,
  BillingsOrderRelatedTaxiTaxiItemContractDetails,
} from "./billings-order-related-taxi-taxi";

const createDataItemStatus = (
  status: BillingsOrderRelatedTaxiTaxiResponseDateBillingStatus,
): BillingStatus => {
  switch (status) {
    case BillingsOrderRelatedTaxiTaxiResponseDateBillingStatus.CREATED:
      return BillingStatus.CREATED;
    case BillingsOrderRelatedTaxiTaxiResponseDateBillingStatus.ACCEPTED:
      return BillingStatus.ACCEPTED;
    case BillingsOrderRelatedTaxiTaxiResponseDateBillingStatus.REJECTED:
      return BillingStatus.REJECTED;
    case BillingsOrderRelatedTaxiTaxiResponseDateBillingStatus.REOPEN_REQUEST:
      return BillingStatus.REOPEN_REQUEST;
    case BillingsOrderRelatedTaxiTaxiResponseDateBillingStatus.REOPENED:
      return BillingStatus.REOPENED;
  }
};

const createDataItemModel = (
  billingModel: BillingsOrderRelatedTaxiTaxiResponseContractBillingModel,
): BillingModel => {
  switch (billingModel) {
    case BillingsOrderRelatedTaxiTaxiResponseContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsOrderRelatedTaxiTaxiResponseContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsOrderRelatedTaxiTaxiResponseContractBillingModel.OTHER:
      return BillingModel.OTHER;
    case BillingsOrderRelatedTaxiTaxiResponseContractBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createDataItemContractDetails = (
  orderForwardingAction: BillingsOrderRelatedTaxiTaxiResponseOrderForwardingAction,
): BillingsOrderRelatedTaxiTaxiItemContractDetails => {
  return {
    companyName: orderForwardingAction.contract.consumerTaxi.displayName,
    distanceRate: orderForwardingAction.contract.distanceRate,
    model: createDataItemModel(orderForwardingAction.contract.model),
  };
};

const createDataItem = (
  data: BillingsOrderRelatedTaxiTaxiResponseDate,
): BillingsOrderRelatedTaxiTaxiItem => {
  return {
    billingUuid: data.id,
    forwardingUuid: data.orderForwardingAction.id,
    contractDetails: createDataItemContractDetails(data.orderForwardingAction),
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    distance: data.distance,
    amountForDistance: data.amountForDistance,
    internalOrderId:
      data.orderForwardingAction.transportingOrder.cargoOrder.humanId,
    allContributionsAmount: data.allContributionsAmount,
    isDraft: data.draft,
    date: data.date,
    sumOfBonuses: data.sumOfBonuses,
    sumOfPenalties: data.sumOfPenalties,
    status: createDataItemStatus(data.status),
    readOnly: data.readOnly,
  };
};

const createData = (
  responseData: BillingsOrderRelatedTaxiTaxiResponseDate[],
): BillingsOrderRelatedTaxiTaxiItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: BillingsOrderRelatedTaxiTaxiResponse,
): BillingsOrderRelatedTaxiTaxi => {
  return {
    data: createData(response.data),
  };
};

const billingsOrderRelatedTaxiTaxiFactory = {
  create,
};

export default billingsOrderRelatedTaxiTaxiFactory;
